import InstagramIcon from "@/assets/colorable/instagram.svg?react";
import EmptySocialLink from "@/components/Common/Influencer/InfluencerCard/EmptySocialLink";
import clsxm from "@/lib/clsxm";
import {memo, type FC} from "react";

const InstagramProfileLink: FC<{
  username: string | null | undefined;
  className?: string;
  withSmallGap?: boolean;
  showInstagramLogo?: boolean;
}> = ({username, className, withSmallGap = false, showInstagramLogo = true}) => {
  if (!username) {
    return <EmptySocialLink socialPlatform="instagram" />;
  }

  return (
    <div
      onClick={event => {
        event.stopPropagation();
        window.open(`https://www.instagram.com/${username}`, "_blank");
      }}
      className={"flex max-w-fit min-w-0 cursor-pointer items-center " + (withSmallGap ? "gap-0.5" : "gap-2")}>
      {showInstagramLogo && <InstagramIcon className="text-primary-dark-solid h-4 w-4" />}
      <span className={clsxm("text-primary-dark-solid text-lg leading-none", className)}>{username}</span>
    </div>
  );
};

export default memo(InstagramProfileLink);
